var _path, _path2, _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRestoreTest(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99935 14.6668C3.64573 14.6668 3.30659 14.5264 3.05654 14.2763C2.80649 14.0263 2.66602 13.6871 2.66602 13.3335V2.66683C2.66602 2.31321 2.80649 1.97407 3.05654 1.72402C3.30659 1.47397 3.64573 1.3335 3.99935 1.3335H9.33268C9.54372 1.33316 9.75274 1.37457 9.9477 1.45534C10.1427 1.53612 10.3197 1.65467 10.4687 1.80416L12.8607 4.19617C13.0106 4.34517 13.1295 4.5224 13.2105 4.71761C13.2915 4.91282 13.333 5.12214 13.3327 5.3335V13.3335C13.3327 13.6871 13.1922 14.0263 12.9422 14.2763C12.6921 14.5264 12.353 14.6668 11.9993 14.6668H3.99935Z",
    stroke: "#4A5464",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33398 1.3335V4.66683C9.33398 4.84364 9.40422 5.01321 9.52925 5.13823C9.65427 5.26326 9.82384 5.3335 10.0007 5.3335H13.334",
    stroke: "#4A5464",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6426_20011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.75 9.99951C5.75 9.40277 5.98705 8.83048 6.40901 8.40852C6.83097 7.98656 7.40326 7.74951 8 7.74951C8.62901 7.75188 9.23276 7.99732 9.685 8.43451L10.25 8.99951",
    stroke: "#4A5464",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.25 7.74951V8.99951H9",
    stroke: "#4A5464",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.25 9.99951C10.25 10.5962 10.0129 11.1685 9.59099 11.5905C9.16903 12.0125 8.59674 12.2495 8 12.2495C7.37099 12.2471 6.76724 12.0017 6.315 11.5645L5.75 10.9995",
    stroke: "#4A5464",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 10.999H5.75V12.249",
    stroke: "#4A5464",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6426_20011"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    fill: "white",
    transform: "translate(5 6.99951)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestoreTest);
export default __webpack_public_path__ + "static/media/restoreTest.68092f47a4e968d761570fc24041f3e5.svg";
export { ForwardRef as ReactComponent };